import { For } from "solid-js"
import { useLanguage } from "@/context/language"
import { Bar, Skeleton } from "./skeleton"
import { TablerIcon } from "./tabler-icons"
import "@/datox/v2/tokens.css"
import "@/datox/v2/home.css"
import "@/datox/v2/reports.css"

const TILES = 8

// The reports grid while it loads: pale tiles in the list's own shape, so the page doesn't jump when they arrive: the
// sheet on its desk, then the client's name, the factsheet and the data line (DESIGN-LOG §70).
export function ReportsSkeleton(props: { label: string }) {
  return (
    <Skeleton class="dx-tiles dx-skel-tiles" label={props.label}>
      <For each={Array.from({ length: TILES })}>
        {() => (
          <div class="dx-tile dx-skel-tile">
            <span class="dx-skel-preview"><i /></span>
            <span class="dx-skel-foot"><Bar w="60%" /><Bar w="45%" /><Bar w="55%" /></span>
          </div>
        )}
      </For>
    </Skeleton>
  )
}

// The whole Reports page before its code and its reports are in (P21, DESIGN-LOG §63): the filters column, the toolbar
// (the page's title as it will be, a bar for its count) and the grid.
export function ReportsPageSkeleton(props: { label?: string }) {
  const language = useLanguage()
  return (
    <Skeleton class="dx-v2 dx-home dx-rl">
      {/* The filters column as the page draws it: its title, the search, Client and its rows, More filters. */}
      <aside class="dx-filters" aria-hidden="true">
        <div class="dx-filters-head"><span>{language.t("datox.v2.home.filters")}</span></div>
        <span class="dx-filter-search"><TablerIcon name="search" size={16} /></span>
        <fieldset class="dx-filter-group dx-filter-group--fill">
          <legend><Bar w={40} /><Bar w={12} /></legend>
          <div class="dx-filter-scroll">
            <For each={Array.from({ length: 12 })}>{(_, index) => (
              <span class="dx-filter-pick"><span class="dx-filter-label"><Bar w={`${48 + ((index() * 17) % 36)}%`} /></span><Bar w={8} /></span>
            )}</For>
          </div>
        </fieldset>
        <div class="dx-filter-more"><span class="dx-filter-toggle"><Bar w={96} /></span></div>
      </aside>
      <div class="dx-home-canvas">
        <div class="dx-home-toolbar" aria-hidden="true"><h1>{language.t("datox.v2.nav.reports")}</h1><span class="dx-home-meta"><Bar w={120} /></span></div>
        <div class="dx-home-body"><ReportsSkeleton label={props.label ?? language.t("datox.v2.reports.loading")} /></div>
      </div>
    </Skeleton>
  )
}
